module.exports = __webpack_public_path__ + "img/contact-form-bg.c8cd1e03.svg";